import React from 'react';
import LazyLoad from 'react-lazyload';
import featureCheck from './feature_check.png';
import * as styles from './styles/styles.module.scss';

type FeatureRowProps = {
  text: string;
  tint: boolean;
  free: boolean;
};

const FeatureRow = ({ text, tint, free }: FeatureRowProps): JSX.Element => {
  const classNames = [styles.featureRow];

  if (tint) {
    classNames.push(styles.featureRowTint);
  }

  return (
    <div className={classNames.join(' ')}>
      <div className={[styles.featureRowCell, styles.featureRowText].join(' ')}>{text}</div>
      <div className={[styles.featureRowCell, styles.featureRowFree].join(' ')}>
        {free && (
          <LazyLoad>
            <img src={featureCheck} className={styles.featureCheckIcon} alt="" />
          </LazyLoad>
        )}
      </div>
      <div className={[styles.featureRowCell, styles.featureRowPro].join(' ')}>
        <LazyLoad>
          <img src={featureCheck} className={styles.featureCheckIcon} alt="" />
        </LazyLoad>
      </div>
    </div>
  );
};

export default FeatureRow;
